import { Component, Fragment } from "react";
import take from "lodash-es/take";
import jsonpack from "jsonpack";

export class Breadcrumbs extends Component {
    renderParts() {
        if (this.props.isLoading) return <div className="loader text-input__loading--line long"/>;

        const count = Number.isFinite(this.props.count) ? `(${this.props.count})` : "";
        const parts = [{
            q: `id:${this.props.id}`,
            name: this.props.reportName ? `${this.props.reportName} ${count}` : null
        }];

        if (this.props.itemId) {
            parts.push({
                q: `id:${this.props.id} itemId:${this.props.itemId}`,
                name: this.props.itemName || `id:${this.props.itemId}`
            });
        }

        // Add any walk requests
        this.props.walk.forEach((prop, index, all) => {
            parts.push({
                q: `id:${this.props.id} itemId:${this.props.itemId} walk:${jsonpack.pack(take(all, index + 1))}`,
                name: Number.isFinite(prop) ? `[${prop}]` : prop
            });
        });

        return parts.map((part, index) => {
            if (index === parts.length - 1) {
                return <span key={`span_only_${part.q}`} className={parts.length === 1 ? "only" : "last"}>{part.name}</span>;
            }

            return (
                <Fragment key={`fragment_${part.q}`}>
                    <a href="#" data-qualifiers={part.q || ""} onClick={this.props.handleBreadcrumb(part.q)}>{part.name}</a>
                    <span className="status-caret">&gt;</span>
                </Fragment>
            );
        });
    }

    render() {
        return (
            <div className="breadcrumbs">
                {this.renderParts()}
            </div>
        );
    }
}
